// 服务前缀 admin or tenantadmin
export const API_CONTEXT = 'admin';
